import {ApiApplicationToken} from '@/model/ApplicationToken';
import {ApiCustomer} from '@/model/Customer';
import {ApiUserToken} from '@/model/UserToken';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';

const ClientId = '17ffabd2-aae1-498a-ac19-297a3f76d604';
const ClientSecret = 'K6Onem46F3m91d2SQUwFL31JrCpAGnUt';

export enum ResourceNone {
  Authorize = '/authorize',
  Token = '/token',
  Customer = '/customer',
  PasswordReset = '/password/reset',
  ChangePassword = '/current/password',
}

export async function authorizeApplication(): Promise<CombinedApiResponse<ApiApplicationToken>> {
  const response = await doApiRequest<ApiApplicationToken>({
    method: Method.Post,
    resource: ResourceNone.Authorize,
    module: Module.None,
    data: {
      ClientId,
      ClientSecret,
    },
  });

  return [response.Data];
}

export async function authorizeUser(data: {
  Username: string;
  Password: string;
  ApplicationToken: string
}): Promise<CombinedApiResponse<ApiUserToken>> {
  const response = await doApiRequest({
    method: Method.Post,
    resource: ResourceNone.Token,
    module: Module.None,
    one_shot: true,
    data,
  });

  return [response.Data];
}

export async function getCustomers(bearerToken?: string): Promise<CombinedApiResponse<ApiCustomer[]>> {
  const response = await doApiRequest({
    method: Method.Get,
    resource: ResourceNone.Customer,
    module: Module.None,
    bearerToken,
  });

  return [response.Data, response.CountAll];
}

export async function resetPassword(Username: string) {
  await doApiRequest({
    method: Method.Post,
    module: Module.None,
    resource: ResourceNone.PasswordReset,
    data: {
      Username,
    },
  });
}

export async function changePassword(CurrentPassword: string, NewPassword: string) {
  await doApiRequest({
    method: Method.Post,
    module: Module.None,
    resource: ResourceNone.ChangePassword,
    data: {
      CurrentPassword,
      NewPassword,
    },
  });
}
